import React from 'react';
import { Col, Form, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import SimpleEditor from '../../../../../../../components/RichTextEditor/SimpleEditor';
import { TranslateFormLabel } from 'components/translateInputAddon';

const DescriptionSection = ({ isView, form }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Row gutter={24}>
        <Col span={6}>
          <Typography.Title level={3}>{t('Descrizione')}</Typography.Title>
        </Col>
        <Col span={18}>
          <Form.Item
            label={
              <TranslateFormLabel
                label={t('Descrizione IT')}
                form={form}
                sourceField='description_it'
                textKey='description'
                targetFields={{
                  en: 'description_en',
                  fr: 'description_fr',
                }}
                disabled={isView}
              />
            }
            name='description_it'
          >
            <SimpleEditor placeholder={t('Inserisci testo')} rows={4} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={6}></Col>
        <Col span={18}>
          <Form.Item label={t('Descrizione EN')} name='description_en'>
            <SimpleEditor placeholder={t('Inserisci testo')} rows={4} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={6}></Col>
        <Col span={18}>
          <Form.Item label={t('Descrizione FR')} name='description_fr'>
            <SimpleEditor placeholder={t('Inserisci testo')} rows={4} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(DescriptionSection);
